import { type SectionType, SectionTypes } from "../types/templateTypes";

export const toTitleCase = (str: string) => {
  const minorWordsPattern = /\b(a|an|and|as|at|but|by|for|if|in|into|is|it|of|on|or|the|to|with)\b/gi;
  return str.toLowerCase().replace(/\b\w+\b/g, match => 
    minorWordsPattern.test(match) ? match.toLowerCase() : match.charAt(0).toUpperCase() + match.slice(1)
  );
}

export const SpacingText = (text:string) => {
  // New lines to HTML
  const textWithLineBreaks = text.replace(/\n/g, '<br>');
  return textWithLineBreaks
}

// html => markdown
export const revertPreprocessedText = (htmlText: string): string => {
  let text = htmlText;

  // Step 1: Replace <br> and <br/> with \n
  text = text.replace(/<br\s*\/?>/gi, '\n');

  // Step 2: Remove <ul> and </ul>
  text = text.replace(/<\/?ul>/gi, '');

  //Step 3: Handle nested <li> items with class "ql-indent-{number}"
  text = text.replace(/<li[^>]*class="[^"]*ql-indent-(\d+)[^"]*"[^>]*>/gi, (_match, p1: string) => {
    const indentLevel = parseInt(p1, 10);
    return ' '.repeat(2 * indentLevel) + '* ';
  });

  // Fallback for regular <li> items (non-indented)
  text = text.replace(/<li[^>]*>/gi, '- ');

  text = text.replace(/<\/li>/gi, '\n'); // Add a newline after each list item
  // Step 4: Convert <strong> tags back to text surrounded by **, and <em> tags back to _
  text = text.replace(/<strong>(.*?)<\/strong>/gi, '**$1**');
  text = text.replace(/<em>(.*?)<\/em>/gi, '*$1*');

  // Step 5: Revert the highlighting of "[Not Mentioned]"
  text = text.replace(/<span style="background-color: #fef08a;">(.*?)<\/span>/gi, '$1');
  text = text.replace(/<span style="background-color: #fef08a;">(.*?)<\/span>/gi, '$1');

  // Step 6. Convert red text back to text surrounded by [[word]]
  text = text.replace(/<span style="color: #ff0303;">(.*?)<\/span>/gi, '$1');
  text = text.replace(/<span style="color: rgb\(255, 3, 3\);">(.*?)<\/span>/gi, '$1');

  // Get rid of spans
  text = text.replace(/<span[^>]*>(.*?)<\/span>/gi, '$1');

  // Step 7. Convert red text back to text surrounded by [[**word**]]
  text = text.replace(/<strong style="color: #ff0303;">(.*?)<\/strong>/gi, '**$1**');
  text = text.replace(/<strong style="color: rgb\(255, 3, 3\);">(.*?)<\/strong>/gi, '**$1**');

  text = text.replace(/<p>/gi, "")
  text = text.replace(/<\/p>/gi, "\n")
  text = text.replace(/\n\n\n/gi, "\n\n")

  // Fix special characters
  text = text.replace(/&lt;/g, '<');
  text = text.replace(/&gt;/g, '>');
  text = text.replace(/&amp;/g, '&');
  text = text.replace(/&quot;/g, '"');
  text = text.replace(/&#39;/g, "'");
  text = text.replace(/&nbsp;/g, '');

  // Remove additional spacing and leftover tags if necessary
  text = text.trim();

  return text;
};

export function filterNotMentionedHTML(input:string) {
    // remove <span style="background-color: rgb(254, 240, 138);">[Not Mentioned]</span>
    input = input.replace(/<span style="background-color: rgb\(254, 240, 138\);">\[Not Mentioned\]<\/span>/gi, '');
    return input.replace(/<span style="background-color: #fef08a;">\[Not Mentioned\]<\/span>/gi, '');
}

// html => markdown (no styling)
export const revertPreprocessedTextNoStyling = (htmlText: string): string => {
  let text = htmlText;

  // Step 1: Replace <br> and <br/> with \n
  text = text.replace(/<br\s*\/?>/gi, '\n');

  // Step 2: Remove <ul> and </ul>
  text = text.replace(/<\/?ul>/gi, '');

  //Step 3: Handle nested <li> items with class "ql-indent-{number}"
  text = text.replace(/<li[^>]*class="[^"]*ql-indent-(\d+)[^"]*"[^>]*>/gi, (_match, p1: string) => {
    const indentLevel = parseInt(p1, 10);
    return ' '.repeat(2 * indentLevel) + '* ';
  });

  // Fallback for regular <li> items (non-indented)
  text = text.replace(/<li[^>]*>/gi, '- ');

  text = text.replace(/<\/li>/gi, '\n'); // Add a newline after each list item

  // Step 4: Convert <strong> tags back to text surrounded by **, remove <em> tags
  text = text.replace(/<strong>(.*?)<\/strong>/gi, '$1');
  text = text.replace(/<em>(.*?)<\/em>/gi, '');

  // Step 5: Revert the highlighting of "[Not Mentioned]"
  text = text.replace(/<span style="background-color: rgb\(254, 240, 138\);">(.*?)<\/span>/gi, '$1');
  text = text.replace(/<span style="background-color: #fef08a;">(.*?)<\/span>/gi, '$1');

  // Step 6. Convert red text back to text surrounded by [[word]]
  text = text.replace(/<span style="color: #ff0303;">(.*?)<\/span>/gi, '$1');
  text = text.replace(/<span style="color: rgb\(255, 3, 3\);">(.*?)<\/span>/gi, '$1');

  // Get rid of spans
  text = text.replace(/<span[^>]*>(.*?)<\/span>/gi, '$1');

  // Step 7. Convert red text back to text surrounded by [[**word**]]
  text = text.replace(/<strong style="color: #ff0303;">(.*?)<\/strong>/gi, '$1');
  text = text.replace(/<strong style="color: rgb\(255, 3, 3\);">(.*?)<\/strong>/gi, '$1');

  text = text.replace(/<p>/gi, "")
  text = text.replace(/<\/p>/gi, "\n")
  text = text.replace(/\n\n\n/gi, "\n\n")

  // Fix special characters
  text = text.replace(/&lt;/g, '<');
  text = text.replace(/&gt;/g, '>');
  text = text.replace(/&amp;/g, '&');
  text = text.replace(/&quot;/g, '"');
  text = text.replace(/&#39;/g, "'");
  text = text.replace(/&nbsp;/g, '');

  // Remove additional spacing and leftover tags if necessary
  text = text.trim();

  return text;
};

// markdown => html
export const preprocessText = (text: string) => {
  let htmlText = '';
  let inList = false; // Flag to track whether we are currently adding list items
  let nestingLevel = 0; // Flag for nested list items
  const decodedText = text.replace(/\\n/g, '\n');
  const lines = decodedText.split('\n');
  let prev_indent = 0;
  lines.forEach((line) => {
      let processedLine = line.replace(/\[\[(.*?)\]\]/g, '<span style="color: #ff0303;">$1</span>');
      processedLine = processedLine
                  .replace(/\[(Not Mentioned|not Mentioned|Not mentioned|not mentioned)\]/gi, '<span style="background-color: #fef08a;">[$1]</span>')
                  .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') // Bold any text surrounded by **
                  .replace(/\*(.*?)\*/g, '<em>$1</em>') // Italic any text surrounded by *
                  .replace("Default:", "")
                  .replace("DEFAULT:", "")

      if (processedLine.trim().startsWith('-')) {
          if (nestingLevel > 0) {
              htmlText += '</ul>'.repeat(nestingLevel);  // Close the nested list
              nestingLevel = 0;
          }

          if (!inList) {
              htmlText += '<ul>';
              inList = true;
          }

          htmlText += `<li>${processedLine.trim().substring(1).trim()}</li>`;
      } else if (processedLine.trim().startsWith('*')) {
          const currentIndent = processedLine.match(/^(\s*)\*/)?.[1]?.length || 0;
          if (nestingLevel === 0 || currentIndent > prev_indent) {
              if (!inList) {
                  // This condition should not normally be met for well-formed input but is here as a safeguard
                  htmlText += '<ul>'; // Start the first-level list implicitly before starting a nested list
                  inList = true;
              }
              htmlText += '<ul>'; // Start a nested list
              nestingLevel += 1;
              prev_indent = currentIndent;
          } else if (currentIndent < prev_indent) {
              htmlText += '</ul>'
              nestingLevel -= 1;
              prev_indent = currentIndent;
          }

          htmlText += `<li>${processedLine.trim().substring(1).trim()}</li>`;
      } else {
          if (nestingLevel > 0) {
              htmlText += '</ul>'.repeat(nestingLevel); // Close the nested list and the parent list item
              nestingLevel = 0;
          }

          if (inList) {
              htmlText += '</ul>';
              inList = false;
          }
          // Apply SpacingText function if defined
          htmlText += `${SpacingText(processedLine.trim())}<br/>`;
      }
  });

  if (nestingLevel > 0) {
      htmlText += '</ul>'; // Ensure closing any open nested list
      nestingLevel -= 1;
  }
  if (inList) {
      htmlText += '</ul>'; // Ensure closing any open list
      inList = false;
  }

  // NOTE: Removing this to accomodate for custom new lines in the template, lmk if it might break something
  // htmlText = htmlText.replace(/(<br\s*\/?>){3,}/gi, '<br\/><br\/>'); // Remove empty lists
  // htmlText = htmlText.replace(/<\/ul>(<br\s*\/?>){2,}/gi, '</ul><br/>'); // Only one newline after each list
  return htmlText;
}

// markdown => html
export const preprocessDischargeText = (text:string) => {
  let htmlText = '';
  let inList = false; // Flag to track whether we are currently adding list items
  let inNestedList = false; // Flag for nested list items
  // convert escaped newlines to actual newlines
  const decodedText = text.replace(/\\n/g, '\n');
  const lines = decodedText.split('\n');
  lines.forEach(line => {
      let processedLine = line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>'); // Bold any text surrounded by **
      processedLine = processedLine.replace(/\*(.*?)\*/g, '<em>$1</em>'); // Italic any text surrounded by *
      if (processedLine.trim().startsWith('-')) {
          if (inNestedList) {
              htmlText += '</ul>'; // Close the nested list
              inNestedList = false;
          }
          if (!inList) {
              htmlText += '<ul>';
              inList = true;
          }
          htmlText += `<li>${processedLine.trim().substring(1).trim()}</li>`;
      } else if (processedLine.trim().startsWith('*')) {
          if (!inNestedList) {
              if (!inList) {
                  // This condition should not normally be met for well-formed input but is here as a safeguard
                  htmlText += '<ul>'; // Start the first-level list implicitly before starting a nested list
                  inList = true;
              }
              htmlText += '<ul>'; // Start a nested list
              inNestedList = true;
          }
          htmlText += `<li>${processedLine.trim().substring(1).trim()}</li>`;
      } else {
          if (inNestedList) {
              htmlText += '</ul></li>'; // Close the nested list and the parent list item
              inNestedList = false;
          }
          if (inList) {
              htmlText += '</ul>';
              inList = false;
          }
          // Apply SpacingText function if defined
          htmlText += `${SpacingText ? SpacingText(processedLine) : processedLine}<br/>`;
      }
  });

  if (inNestedList) {
      htmlText += '</ul>'; // Ensure closing any open nested list
      inNestedList = false;
  }
  if (inList) {
      htmlText += '</ul>'; // Ensure closing any open list
      inList = false;
  }

  htmlText = htmlText.replace(/(<br\s*\/?>){3,}/gi, '<br/><br/>'); // Remove empty lists

  return htmlText;
}

export const locale_codes = {
  "English": "en-US",
  "Spanish": "es",
  "English (US)": "en-US",
  "English (UK)": "en-GB",
  "English (AU)": "en-AU",
};

export const timestampsToHumanReadable = (timestamp:number, session_language:string) => {
  const date = new Date(timestamp * 1000);
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  };
  const locale = locale_codes[session_language as keyof typeof locale_codes] || "en-US";
  return date.toLocaleString([locale, "en-US"], options).replace(',', '').replace(/\s(am|pm)$/i, match => match.toUpperCase());
}


export const decodeTranscriptTimestamps = (transcript:string, session_language:string) => {
  const regex = /<<(\d+(?:\.\d+)?)>>/g;
  const matches = transcript.match(regex);
  if (matches) {
    matches.forEach(match => {
      const timestamp = parseFloat(match.replace(/<<|>>/g, ''));
      const humanReadable = timestampsToHumanReadable(timestamp, session_language);
      transcript = transcript.replaceAll(match, `<<${humanReadable}>>`);
    });
  }
  return transcript;
}



export type TranscriptEntry = {
  timestamp: string
  timestamp_full: string
  text: string
}

export const ConvertToTranscriptEntry = (text:string, startTimestamp:string | undefined): TranscriptEntry[] => {
  const entries = [...text.matchAll(/<<([^>]+)>>:([^<]*)/g)].map(([, timestamp, content]): TranscriptEntry => ({
    timestamp_full: timestamp ?? '',
    timestamp: extractTime((timestamp ?? '').trim()),
    text: (content ?? '').trim()
  }));
  if (entries.length === 0) {
    return [{ timestamp: extractTime(startTimestamp ?? ""), timestamp_full: startTimestamp ?? "", text: text.trim() }];
  }
  return entries
}

function extractTime(datetime: string): string {
  // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
  return datetime.split(' ')[1] + ' ' + datetime.split(' ')[2];
}

export const formatTranscript = (transcript:string, startTimestamp:string | undefined, session_language:string) => {
  transcript = decodeTranscriptTimestamps(transcript, session_language);
  transcript = SpacingText(transcript);
  return ConvertToTranscriptEntry(transcript, startTimestamp);
}

export const secondBetweenTimestamps = (startTimestamp: string, endTimestamp: string) => {
  const start = new Date(startTimestamp).getTime() / 1000;
  const end = new Date(endTimestamp).getTime() / 1000;
  return Math.abs(end - start);
}

function escapeRegExp(string:string) {
  return string.replace(/[.*+?^${}()[\]\\]/g, '\\$&');  // Adds a backslash before special characters
}

export function splitNoteIntoSectionWithDefinition(
  note: string,
  definition: SectionType[],
  ignore_section_types: SectionTypes[] = []
): Record<string, string> {
  // Clean up new lines to ensure consistent formatting
  const cleanNewLines: string = note.replace(/\n /g, '\n');

  const filteredDefinition =  definition.filter(section => !ignore_section_types.includes(section.type))

  // Escape special characters in section names and join them into a regex alternation group
  const escapedSectionNames: string[] = filteredDefinition
      .map(section => section.name)
      .filter((key): key is string => key !== undefined)
      .map(name => escapeRegExp(name)); // Escape special regex characters

  const dictionaryKeys: string = escapedSectionNames.join('|');

  // Build the regex pattern
  const pattern: string = `^\\s*(?:\\*{1,3}\\s*(${dictionaryKeys})\\s*\\*{1,3}|(${dictionaryKeys}))\\s*:\\s*`;

  // Compile the regex pattern with ignore case and multiline flags
  const regex: RegExp = new RegExp(pattern, 'im'); // 'i' for ignore case, 'm' for multiline

  // Find all matches of the headings
  let matches: RegExpExecArray | null;
  const sections: { heading: string; content: string }[] = [];
  const regexGlobal: RegExp = new RegExp(regex.source, 'gim'); // 'g' for global search

  // Keep track of the positions
  let lastIndex: number = 0;

  while ((matches = regexGlobal.exec(cleanNewLines)) !== null) {
      const heading: string = (matches[1] || matches[2] || "").trim();
      const headingStartIndex: number = matches.index;
      const headingEndIndex: number = regexGlobal.lastIndex;
      if (lastIndex < headingStartIndex) {
          // Content before this heading (belongs to the previous section)
          const content: string = cleanNewLines.substring(lastIndex, headingStartIndex).trim();
          const lastSection = sections[sections.length - 1];
          if (lastSection) {
              lastSection.content = content;
          }
      }

      // Add the new heading
      sections.push({ heading: heading, content: '' });

      lastIndex = headingEndIndex;
  }

  // Add the content after the last heading
  if (sections.length > 0 && lastIndex < cleanNewLines.length) {
      const content: string = cleanNewLines.substring(lastIndex).trim();
      const lastSection = sections[sections.length - 1];
      if (lastSection) {
          lastSection.content = content;
      }
  }

  // Build the result object
  const result: Record<string, string> = definition.reduce(
      (acc: Record<string, string>, section: SectionType) => {
          if (section.name) {
              const key: string = section.name.toLowerCase().trim();
              const sectionData = sections.find(s => s.heading.toLowerCase() === key);
              acc[key] = sectionData ? sectionData.content : '';
          }
          return acc;
      },
      {}
  );

  return result;
}

export function getFirstAlphanumericCharacter(str: string | undefined): string {
    if (!str) {
        return '';
    }
    
    const match = str.match(/[A-Za-z0-9]/);
    return match ? match[0].toUpperCase() : '';
}